import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { focusRing, hoverable } from '@/design-system';

export const FollowingRows = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[12],
}));

export const FollowingRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing[12],
  padding: theme.spacing[12],
  borderRadius: theme.radius[16],
  backgroundColor: theme.colors.background.raised,
}));

export const FollowingRowLink = styled(Link)(({ theme }) => ({
  ...hoverable(theme, 'text'),
  ...focusRing(theme),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[12],
  minWidth: 0,
  borderRadius: theme.radius[12],
  color: theme.colors.text.primary,
  textDecoration: 'none',
}));

export const FollowingLogo = styled('img')(({ theme }) => ({
  width: 40,
  height: 40,
  flexShrink: 0,
  objectFit: 'cover',
  borderRadius: theme.radius[8],
  backgroundColor: theme.colors.background.overlay,
}));

export const FollowingLogoFallback = styled('div')(({ theme }) => ({
  width: 40,
  height: 40,
  flexShrink: 0,
  borderRadius: theme.radius[8],
  backgroundColor: theme.colors.background.overlay,
}));

export const FollowingText = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

export const FollowingSkeletonMain = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[12],
  flex: 1,
  minWidth: 0,
}));

export const FollowingSkeletonLogo = styled('div')({
  width: 40,
  height: 40,
  flexShrink: 0,
});

export const FollowingSkeletonText = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
});

export const FollowingSkeletonAction = styled('div')({
  width: 80,
  flexShrink: 0,
});
